<script>
export default {
  props: ['loading','filters','results','formats'],
  data() {
    return {

    }
  },
  created() {

  },
  methods: {

  }
}
</script>

<template>
  <div class="p-2 small">
    <div class="row m-0 small">
      <div class="_w-n-255 _w-m-255 p-2" v-for="(item, item_i) in results" :key="item_i">
        <div class="border border-light border-hover-primary _transition-2">
          <div class="_p-t-65p position-relative _c-pointer" @dblclick="$emit('viewfile', item)" :style="'background-image: url(' + require('@assets/images/trasnparent-bg.png') + ')'">
            <div class="position-absolute _pos-t-0 _pos-r-0 _pos-b-0 _pos-l-0 text-center">
              <img v-if="item.type == 'Folder'" class="_h-m-100p _w-m-100p py-4" src="@assets/images/folder-icon.png" >
              <img v-else-if="formats.images.includes(item.type)" class="_h-m-100p _w-m-100p" :src="item.url" >
              <img v-else-if="formats.docs.includes(item.type)" class="_h-m-100p _w-m-100p py-4" src="@assets/images/file-icons/doc.svg" >
              <img v-else-if="formats.powerpoints.includes(item.type)" class="_h-m-100p _w-m-100p py-4" src="@assets/images/file-icons/ppt.svg" >
              <img v-else-if="formats.spreadsheets.includes(item.type)" class="_h-m-100p _w-m-100p py-4" src="@assets/images/file-icons/xls.svg" >
              <img v-else-if="formats.archives.includes(item.type)" class="_h-m-100p _w-m-100p py-4" src="@assets/images/file-icons/zip.svg" >
              <img v-else-if="item.type == '3ds'" class="_h-m-100p _w-m-100p py-4" src="@assets/images/file-icons/3ds.svg" >
              <img v-else-if="item.type == 'aac'" class="_h-m-100p _w-m-100p py-4" src="@assets/images/file-icons/aac.svg" >
              <img v-else-if="item.type == 'ai'" class="_h-m-100p _w-m-100p py-4" src="@assets/images/file-icons/ai.svg" >
              <img v-else-if="item.type == 'avi'" class="_h-m-100p _w-m-100p py-4" src="@assets/images/file-icons/avi.svg" >
              <img v-else-if="item.type == 'cad'" class="_h-m-100p _w-m-100p py-4" src="@assets/images/file-icons/cad.svg" >
              <img v-else-if="item.type == 'cdr'" class="_h-m-100p _w-m-100p py-4" src="@assets/images/file-icons/cdr.svg" >
              <img v-else-if="item.type == 'css'" class="_h-m-100p _w-m-100p py-4" src="@assets/images/file-icons/css.svg" >
              <img v-else-if="item.type == 'dat'" class="_h-m-100p _w-m-100p py-4" src="@assets/images/file-icons/dat.svg" >
              <img v-else-if="item.type == 'dll'" class="_h-m-100p _w-m-100p py-4" src="@assets/images/file-icons/dll.svg" >
              <img v-else-if="item.type == 'dmg'" class="_h-m-100p _w-m-100p py-4" src="@assets/images/file-icons/dmg.svg" >
              <img v-else-if="item.type == 'eps'" class="_h-m-100p _w-m-100p py-4" src="@assets/images/file-icons/eps.svg" >
              <img v-else-if="item.type == 'fla'" class="_h-m-100p _w-m-100p py-4" src="@assets/images/file-icons/fla.svg" >
              <img v-else-if="item.type == 'flv'" class="_h-m-100p _w-m-100p py-4" src="@assets/images/file-icons/flv.svg" >
              <img v-else-if="item.type == 'html'" class="_h-m-100p _w-m-100p py-4" src="@assets/images/file-icons/html.svg" >
              <img v-else-if="item.type == 'indd'" class="_h-m-100p _w-m-100p py-4" src="@assets/images/file-icons/indd.svg" >
              <img v-else-if="item.type == 'iso'" class="_h-m-100p _w-m-100p py-4" src="@assets/images/file-icons/iso.svg" >
              <img v-else-if="item.type == 'js'" class="_h-m-100p _w-m-100p py-4" src="@assets/images/file-icons/js.svg" >
              <img v-else-if="item.type == 'midi'" class="_h-m-100p _w-m-100p py-4" src="@assets/images/file-icons/midi.svg" >
              <img v-else-if="item.type == 'mov'" class="_h-m-100p _w-m-100p py-4" src="@assets/images/file-icons/mov.svg" >
              <img v-else-if="item.type == 'mp3'" class="_h-m-100p _w-m-100p py-4" src="@assets/images/file-icons/mp3.svg" >
              <img v-else-if="item.type == 'mpg'" class="_h-m-100p _w-m-100p py-4" src="@assets/images/file-icons/mpg.svg" >
              <img v-else-if="item.type == 'pdf'" class="_h-m-100p _w-m-100p py-4" src="@assets/images/file-icons/pdf.svg" >
              <img v-else-if="item.type == 'php'" class="_h-m-100p _w-m-100p py-4" src="@assets/images/file-icons/php.svg" >
              <img v-else-if="item.type == 'ps'" class="_h-m-100p _w-m-100p py-4" src="@assets/images/file-icons/ps.svg" >
              <img v-else-if="item.type == 'psd'" class="_h-m-100p _w-m-100p py-4" src="@assets/images/file-icons/psd.svg" >
              <img v-else-if="item.type == 'raw'" class="_h-m-100p _w-m-100p py-4" src="@assets/images/file-icons/raw.svg" >
              <img v-else-if="item.type == 'sql'" class="_h-m-100p _w-m-100p py-4" src="@assets/images/file-icons/sql.svg" >
              <img v-else-if="item.type == 'tif'" class="_h-m-100p _w-m-100p py-4" src="@assets/images/file-icons/tif.svg" >
              <img v-else-if="item.type == 'txt'" class="_h-m-100p _w-m-100p py-4" src="@assets/images/file-icons/txt.svg" >
              <img v-else-if="item.type == 'wmv'" class="_h-m-100p _w-m-100p py-4" src="@assets/images/file-icons/wmv.svg" >
              <img v-else-if="item.type == 'xml'" class="_h-m-100p _w-m-100p py-4" src="@assets/images/file-icons/xml.svg" >
            </div>
          </div>
          <div class="card-body p-0 border-top border-light">
            <div class="d-flex border-bottom border-light _h-30">
              <div class="mr-auto p-1 text-truncate" v-tippy :content="item.name" @click="$emit('copy', item.name)"><strong>{{item.name}}</strong></div>
              <div v-if="item.type != 'Folder'" class="border-left border-light overflow-hidden">
                <button type="button" class="btn btn-sm btn-white border-0" @click="$emit('copy', item.url)" v-tippy content="Click to copy URL"><Icon icon="ri:file-copy-line" /></button>
              </div>
            </div>
            <div class="d-flex _h-30">
              <div class="mr-auto p-1 text-muted text-truncate">
                <ul class="list-inline m-0 ">
                  <li class="list-inline-item">{{item.type}}</li>
                  <li class="list-inline-item border-left border-light pl-1">{{formatSize(item.size)}}</li>
                </ul>
              </div>
              <div class="border-left border-light dropdown">
                <button type="button" class="btn btn-sm btn-white border-0" data-toggle="dropdown"><Icon icon="ri:more-2-line" /></button>
                <div class="dropdown-menu">
                  <a class="dropdown-item _c-pointer" @click="$emit('viewfile', item)">View</a>
                  <!-- <a class="dropdown-item _c-pointer">Edit</a> -->
                  <a class="dropdown-item _c-pointer" @click="$emit('downloadfiles', item)">Download</a>
                  <a v-if="item.type != 'Folder'" class="dropdown-item _c-pointer" @click="$emit('renamefile', item)">Rename</a>
                  <a class="dropdown-item _c-pointer" @click="$emit('deletefile', item)">Delete</a>
                  <a class="dropdown-item _c-pointer" @click="$emit('viewproperties', item)">Properties</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
